export enum RichTextComponentType {
  List = 'RichTextList',
  Text = 'RichTextText'
}

export enum RichTextTextType {
  Heading_1 = 'heading-1',
  Heading_2 = 'heading-2',
  Heading_3 = 'heading-3',
  Heading_4 = 'heading-4',
  Heading_5 = 'heading-5',
  Paragraph = 'paragraph',
  hyperlink = 'hyperlink'
}

export enum RichTextListType {
  Ordered_list = 'ordered-list',
  Unordered_list = 'unordered-list'
}

export enum RichTextTextVariant {
  Bold = 'BOLD',
  Italic = 'ITALIC',
  Underline = 'UNDERLINE'
}
